/**
 * 서버 오류 코드 · 자격 사유 → 사용자가 실제로 할 수 있는 조치 문구.
 * 단답형은 "선택지" 가 아니라 "답안" 이라 같은 사유도 카피가 갈린다(FillSlotVariant).
 */
import { type QuestionCardAiErrorCode } from '../consts/questionCardAi.const';
import { type QuestionCardAiCopy } from '../hooks/useQuestionCardAiCopy';
import {
  type EligibilityReason,
  type FillSlotVariant,
} from '../types/questionCardAi.types';

type ReasonCopyKey = keyof QuestionCardAiCopy['reason'];

const ANSWER_VARIANT_REASON: Partial<Record<EligibilityReason, ReasonCopyKey>> =
  {
    noEmptySlots: 'noEmptyAnswers',
  };

export const eligibilityReasonMessage = (
  copy: QuestionCardAiCopy,
  reason: EligibilityReason,
  variant: FillSlotVariant = 'choice',
): string =>
  copy.reason[
    (variant === 'answer' && ANSWER_VARIANT_REASON[reason]) || reason
  ];

/** 서버 도메인 거절 코드 → 같은 뜻의 자격 사유. 키는 서버 코드 목록으로 검사된다. */
const REASON_BY_CODE = new Map<string, EligibilityReason>(
  Object.entries({
    NO_EMPTY_SLOTS: 'noEmptySlots',
    UNSUPPORTED_QUIZ_TYPE: 'unsupportedType',
    INVALID_QUESTION: 'emptyQuestion',
  } satisfies Partial<Record<QuestionCardAiErrorCode, EligibilityReason>>),
);

/** 매핑이 없으면 일반 실패 문구로 떨어진다. */
export const questionCardAiErrorMessage = (
  copy: QuestionCardAiCopy,
  code: string | undefined,
  variant: FillSlotVariant = 'choice',
): string => {
  const reason = code ? REASON_BY_CODE.get(code) : undefined;
  return reason
    ? eligibilityReasonMessage(copy, reason, variant)
    : copy.error.title;
};
